import getterTypes from './getter-types'

export default {
  [getterTypes.GET_TOTAL_PRICE]: state => state.totalPrice,
  [getterTypes.GET_TOTAL_PRICE_FORMATTED]: state => state.totalPriceFormatted,
  [getterTypes.GET_ITEM_PRICE]: state => state.itemPrice,
  [getterTypes.GET_ITEM_PRICE_FORMATTED]: state => state.itemPriceFormatted,
  [getterTypes.GET_TOTAL_PACKAGING_PRICE]: state => state.totalPackagingPrice,
  [getterTypes.GET_TOTAL_PACKAGING_PRICE_FORMATTED]: state => state.totalPackagingPriceFormatted,
  [getterTypes.GET_LINES]: state => state.lines,
  [getterTypes.GET_CART_GROUPS]: state => state.cartGroups,
  [getterTypes.GET_OFFER_MEAL_CART_LINE]: state => offerMeal => {
    let cartGroup = state.cartGroups.find(cartGroup => {
      if (cartGroup.type !== 'offer_category') return null;
      return cartGroup.data.offer_category_id === offerMeal.offer_category_id;
    });

    if (!cartGroup) return null;

    return cartGroup.cart_lines.find(cartLine => {
      if (cartLine.type !== 'offer_meal') return null;
      return cartLine.data.offer_meal_id === offerMeal.id;
    });
  },
  [getterTypes.GET_LUNCH_MEAL_CART_LINE]: state => ({lunchMeal, lunchDay}) => {
    let cartGroup = state.cartGroups.find(cartGroup => {
      if (cartGroup.type !== 'lunch_day') return null;
      return cartGroup.data.lunch_day_id === lunchDay.id;
    });

    if (!cartGroup) return null;

    return cartGroup.cart_lines.find(cartLine => {
      if (cartLine.type !== 'lunch_meal') return null;
      return cartLine.data.lunch_meal_id === lunchMeal.id;
    });
  },
  [getterTypes.GET_ORDER_DELIVERY_TYPE]: state => state.orderDeliveryType,
  [getterTypes.GET_ORDER_PAYMENT_TYPES]: state => state.orderPaymentTypes,
  [getterTypes.GET_ORDER_PAYMENT_TYPE]: state => state.orderPaymentType,
  [getterTypes.GET_UPDATE_CART_URL]: state => state.updateCartUrl,
  [getterTypes.GET_FIRSTNAME]: state => state.firstname,
  [getterTypes.GET_LASTNAME]: state => state.lastname,
  [getterTypes.GET_NOTE]: state => state.note,
  [getterTypes.GET_EMAIL]: state => state.email,
  [getterTypes.GET_PHONE]: state => state.phone,
  [getterTypes.GET_ADDRESS]: state => state.address,
  [getterTypes.GET_ERRORS]: state => state.errors,
  [getterTypes.GET_IS_VALID]: state => state.is_valid,
  [getterTypes.GET_TOTAL_AMOUNT]: state => state.totalAmount,
}
